import { useUiStrings } from '@/hooks/useUiStrings'

interface RemoveMeetingModalProps {
  removing: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirm Remove from History — hides the row for the recipient only
 * (does not revoke anyone's access). Distinct from Revoke.
 */
export default function RemoveMeetingModal({
  removing,
  onClose,
  onConfirm,
}: RemoveMeetingModalProps) {
  const { t } = useUiStrings()

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-slate-950/30 px-3 py-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="remove-meeting-title"
    >
      <button
        type="button"
        aria-label={t.close}
        className="fixed inset-0 cursor-default"
        onClick={onClose}
      />

      <div className="animate-scale-in relative w-full max-w-md rounded-2xl border border-[var(--border-color)] bg-[var(--bg-secondary)] p-5 shadow-2xl sm:p-6">
        <h2
          id="remove-meeting-title"
          className="text-lg font-bold text-[var(--text-primary)]"
        >
          {t.removeFromHistoryTitle}
        </h2>
        <p className="mt-2 text-sm text-[var(--text-secondary)]">
          {t.removeFromHistoryBody}
        </p>

        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={removing}
            className="rounded-lg border border-[var(--border-color)] px-4 py-2 text-sm font-semibold text-[var(--text-secondary)] transition-colors hover:bg-[var(--bg-tertiary)] disabled:opacity-50"
          >
            {t.cancel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={removing}
            className="rounded-lg bg-red-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-600 disabled:opacity-50"
          >
            {removing ? t.loading : t.removeFromHistory}
          </button>
        </div>
      </div>
    </div>
  )
}
